/* lib/api/team.js — порт боевого клиента команды workspace (frontend/src/lib/api/team.js, 1:1).
 * Все эндпоинты скоупятся по wsId в пути; client.js дополнительно шлёт X-Workspace-Id (та же ws).
 * Контракт {ok,status,data}. GET → {members, invitations}; 403 не-админу (→ ForbiddenState).
 * Роли доступа (C1): {roles:[{id,name,grants,members_count}]}; grants — карта {key:false}
 * ТОЛЬКО из запрещённых ключей каталога lib/analyticsAccess.js (отсутствие ключа = разрешено).
 * preview/accept приглашений — отдельный auth-флоу (/api/invitations/, без wsId); их потребляют
 * экраны auth/InviteAccept + SignIn (pending-invite после входа), не настройки команды. */

import { apiFetch } from './client.js';

// ── Команда workspace ─────────────────────────────────────────────────────

// {ok, data:{members:[...], invitations:[...]}}. 403 code='forbidden' не-админу.
export const listMembers = (workspaceId) =>
  apiFetch(`/api/workspaces/${workspaceId}/members/`);

// {ok, data:{invitation}}. Тело: {email, role_name?, is_admin?, role_id?}. 409 code='already_member'.
export const inviteMember = (workspaceId, body) =>
  apiFetch(`/api/workspaces/${workspaceId}/members/invite/`, {
    method: 'POST', body,
  });

// 200 {ok} / 400 cannot_remove_owner.
export const revokeMember = (workspaceId, membershipId) =>
  apiFetch(`/api/workspaces/${workspaceId}/members/${membershipId}/`, {
    method: 'DELETE',
  });

// {ok, data:{member}}. Тело: {role_name?, is_admin?, role_id: int|null,
//   permission_overrides: {key:bool}} — overrides ПОЛНАЯ замена ({} очищает).
// Ответ member += role:{id,name}|null, permission_overrides.
// 400 cannot_demote_owner / invalid_role, 403 forbidden.
export const updateMember = (workspaceId, membershipId, body) =>
  apiFetch(`/api/workspaces/${workspaceId}/members/${membershipId}/`, {
    method: 'PATCH', body,
  });

// ── Роли доступа workspace (C1) ───────────────────────────────────────────
// Все ручки админские (403 code='forbidden' не-админу); скоуп — wsId в пути.

// {ok, data:{roles:[{id, name, grants:{key:bool}, members_count}]}}.
export const listRoles = (workspaceId) =>
  apiFetch(`/api/workspaces/${workspaceId}/roles/`);

// 201 {ok, data:{role}}. Тело: {name, grants}. 400 {'detail','code':'invalid_name'|'invalid_grants'}.
export const createRole = (workspaceId, body) =>
  apiFetch(`/api/workspaces/${workspaceId}/roles/`, {
    method: 'POST', body,
  });

// {ok, data:{role}}. Тело: {name?, grants?} — grants ПОЛНАЯ замена. Коды ошибок как у POST.
export const updateRole = (workspaceId, roleId, body) =>
  apiFetch(`/api/workspaces/${workspaceId}/roles/${roleId}/`, {
    method: 'PATCH', body,
  });

// 204 без тела; участники с этой ролью остаются без роли (полный доступ).
export const deleteRole = (workspaceId, roleId) =>
  apiFetch(`/api/workspaces/${workspaceId}/roles/${roleId}/`, {
    method: 'DELETE',
  });

// 200 {ok} / 409 already_accepted.
export const revokeInvitation = (workspaceId, invitationId) =>
  apiFetch(`/api/workspaces/${workspaceId}/invitations/${invitationId}/`, {
    method: 'DELETE',
  });

// {ok, data:{invitation}}. Повторно шлёт письмо+in-app, продлевает истёкший срок,
// токен не меняет. 409 already_accepted / 400 invitation_revoked / 429 rate_limited.
export const resendInvitation = (workspaceId, invitationId) =>
  apiFetch(`/api/workspaces/${workspaceId}/invitations/${invitationId}/resend/`, {
    method: 'POST',
  });

// ── Приглашение: preview / accept (auth-флоу) ───────────────────────────────

// PUBLIC (AllowAny). {ok, data:{workspace_name, workspace_kind, invited_email, role_name,
//   is_authenticated, requires_register, expired, already_accepted, revoked}} | 404 code='invalid_token'.
export const previewInvitation = (token) =>
  apiFetch('/api/invitations/preview/', { method: 'POST', body: { token } });

// Требует сессию. {ok, data:{workspace}} | 400 invitation_expired/invitation_revoked,
//   403 email_mismatch, 409 already_accepted/already_member. Переключает active ws на сервере.
export const acceptInvitation = (token) =>
  apiFetch('/api/invitations/accept/', { method: 'POST', body: { token } });
